
import { Container, Row, Col, Nav } from "react-bootstrap";
import trainingImg from "../assets/img/trainingPic.jpg";
import exampleImage1 from '../assets/img/example1.jpg';
import exampleImage2 from '../assets/img/example2.jpg';
import exampleImage3 from '../assets/img/example3.jpg';

import fontImage1 from '../assets/img/fontImg.jpg';
import fontImage2 from '../assets/img/fontImg2.png';

import assignMent1Img1 from '../assets/img/assignImg1.jpg';
import assignMent1Img2 from '../assets/img/assignImg2.jpg';
import assignMent1Img3 from '../assets/img/assignImg3.jpg';
import assignMent1Img4 from '../assets/img/assignImg4.jpg';
import assign2Img1 from '../assets/img/assign2Img1.jpg';
import assign2Img2 from '../assets/img/assign2Img2.jpg';
import assign2Img3 from '../assets/img/assign2Img3.jpg';
import assign2Img4 from '../assets/img/assign2Img4.jpg';

import designImg1 from '../assets/img/designImg1.jpg';
import designImg2 from '../assets/img/designImg2.jpg';
import designImg2b from '../assets/img/designImg2b.jpg';
import designImg3 from '../assets/img/designImg3.jpg';
import designImg3b from '../assets/img/designImg3b.jpg';
import designImg4 from '../assets/img/designImg4.jpg';
import designImg5 from '../assets/img/designImg5.jpg';
import designImg5b from '../assets/img/designImg5b.jpg';
import designvid6 from '../assets/img/designvid6a.mp4';
import designImg6b from '../assets/img/advanceGifImg.gif';
import designImg7 from '../assets/img/designImg7.jpg';
import designImg7b from '../assets/img/designImg7b.jpg';
import designImg8 from '../assets/img/designImg8.jpg';

import lesImg1 from '../assets/img/balancePic.jpg';
import lesImg2 from '../assets/img/aliagnPic1.jpg';
import lesImg3 from '../assets/img/aliagnPic2.jpg';
import lesImg4 from '../assets/img/aliagnPic3.jpg';
import lesImg5 from '../assets/img/aliagnPic4.jpg';
import lesImg6 from '../assets/img/aliagnPic5.jpg';
import lesImg7 from '../assets/img/aliagnPic6.jpg';
import lesImg8 from '../assets/img/visualhPic.jpg';
import lesImg8b from '../assets/img/colorweelImg.jpg';
import lesImg9 from '../assets/img/contrastPic.jpg';
import lesImg10 from '../assets/img/typoPic.jpg';
import lesImg11 from '../assets/img/fontImg.jpg';
import lesImg12 from '../assets/img/solidBackPic.jpg';
import lesImg13 from '../assets/img/textureBackPic.jpg';
import lesImg14 from '../assets/img/gradientBackPic.jpg';
import lesImg15 from '../assets/img/imagBackPic.jpg';
import lesImg16 from '../assets/img/pstwheel.jpg';
import lesImg17 from '../assets/img/colorImg1.jpg';
import lesImg18 from '../assets/img/colorImg2.jpg';
import lesImg19 from '../assets/img/colorImg3.jpg';
import lesImg20 from '../assets/img/colorImg4.jpg';
import lesImg21 from '../assets/img/colorImg5.jpg';
import lesImg22 from '../assets/img/colorImg6.jpg';
import lesImg23 from '../assets/img/colorImg7.jpg';

import advanceDesignGifImg from '../assets/img/advanceGifImg.gif';

import masterClassImg from '../assets/img/masterClassImg.jpg';

import colorwheelImage from '../assets/img/colorweelImg.jpg';
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import canvaImg from "../assets/img/canvaImg.jpg";
import pixellabImg from "../assets/img/pixellabImg.jpg";

export const GraphicsTrainingNotes = () => {
 
  return (
    <section className="career" id="career">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h1>7 Days Free Class <span className='quoteHeader'>Graphics Design 101</span> Beginners Training.</h1>
                <h4>Instructor: Christotle Agholor</h4><br />
                
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={trainingImg} alt="Header Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <p>
                  Good Evening... Please get prepared. We wil be Starting in an hour.<br /><br />
                  Are you getting set? ... We will be starting in 30 min.
                  </p><br />

                  <h5 className="chris">Class Begins (DAY ONE)</h5>
                  <p>Good evening great minds, glad you could join us in this training. My name is Christotle Agholor and by His grace I wil be taking you on this class.</p><br />
                  <p>I am a Graphics Designer, Full Stack Web/Mobile App Developer and a Design Coach.</p><br />
                  <p>I am here to either make you fall in love with graphic design or see ways you can improve.  For these 7 days with me, we would be learning alot of things. Trust me, you will learn the following for *free*</p><br />
                  <p>🔰 Fundamentals of graphic design</p><br />
                  <p>🔰 Introduction to design tools such as Photoshop, CorelDraw, Canva and Pixellab</p><br />
                  <p>🔰You will also be able to create designs such as logos, business cards, flyers etc</p><br />
                  <p>🔰You will learn the principles of graphic design</p><br />
                  <p>And last but not the least how to be a creative designer</p><br />

                  <h5>All that is required of you to enjoy these 7 days are:</h5>
                  <p>🔰A laptop or a smartphone</p><br />
                  <p>🔰Photoshop and CorelDraw installed if you have a Laptop</p><br />
                  <p>🔰 Canva and Pixellab if you are using a smartphone or iphone</p><br />

                  <p>NOTE: Our classes would be short and straight to the point.</p><br />
                  <p>There would also be at least 2 practicals for all the design tools</p><br />

                  <h3> Introduction to graphic design</h3><br />
                  <h5>1. What is graphic design?</h5>
                  <p>Graphic design is the process of creating visual content to communicate.</p><br />
                  <p>It is the use of design elements to create beautiful and engaging visual contents.</p><br />

                  <h5>See Examples bellow:</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={exampleImage1} alt="example Img"/>
                    <img src={exampleImage2} alt="example Img"/>
                    <img src={exampleImage3} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h3>2. Who is a graphic designer?</h3>
                  <p>A graphic designer is someone who understands the principles of design and can apply them to elements such as lines, colors, form, shapes, and texture to communicate visually</p><br />
                  <p>Basically, a graphic designer brings imagination and information to life</p><br />
                  <p>Unaguably, there are lots and lots of graphic designers out there. But the only thing that separates us is our uniqueness and ability to be *valuable*</p><br />

                  <h3>3. How Important are Graphics Designers?</h3>
                  <p>Well, the only way to test the importance of anything is if it can provide a solution to certain matters.</p><br />
                  <p>Graphic Design is important not just to those who do business online or sell products; every business or brand that wants to connect with its customers, would always need the services of a graphic designer.</p><br />

                  <h3>4. Things you would need to become a graphic designer</h3>
                  <p>*  A laptop or a good phone.</p><br />
                  <p>* The readiness to learn at all cost</p><br />
                  <p>* Understanding of design elements and principles</p><br />
                  <p>* A mentor</p><br />
                  <p>* A goal</p><br />
                  <p>* A strong will never to give up. ( *Graphic design is not for the faint-hearted* )</p><br />
                  <p>NOTE: There are lots of things you would need. These are just the ones you might need for now. As you began to grow, others will annouce themselves.</p><br />

                  <h3>Key Notes:</h3>
                  <p>* Graphic design is not as easy as some of the pros make it look</p><br />
                  <p>* You would need serious *dedication* and *commitment* if you want to be one of the best someday.</p><br />
                  <p>One more time, I would want to remind you that our classes would always be short and direct, so open up your mind and allow your inner man to flow freely.</p><br />
                  <p>I would also be sending us Daily videos to watch every day. Watch them and summaries and submit them.</p><br />
                  <p>NOTE: these daily videos are not practical, they are for you to learn and exploy as deep as your mind can allow. In a simple term, they are for your personal consumption</p><br />
                  <p>If you are yet to read our free books on design, please do so. They are free for now (Soon it won't be available).</p><br />

                  <h3>Books on Graphic Design</h3>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1T_7rMZR6Ie-P4ASxnETpEv54JQndDG6F' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1T_7rMZR6Ie-P4ASxnETpEv54JQndDG6F</a></p><br />
                                  

                  <h3>TELEGRAM LINK:</h3><br />
                  <p>Bellow is the Telegram Details For Assignment Submission and More:</p><br />

                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={trainingImg} alt="Header Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h5>Here is the link to join the discussion group on telegram</h5>
                  <p>
                  Once you join, introduce yourself in this order<br /><br />
                  <p>Name</p>
                  <p>Location</p>
                  <p>Indicate if you are using a laptop or phone</p>
                  Link: 123456frtjjskkkd&89ghjjj example to be filled later
                  </p><br />

                  <p>Tomorrow we would continue with introduction and also get some practical introductory videos</p><br />
                  <p>Please don't spam or send any message that doesn't relate to this class.</p><br />
                  <p>Also, don't send people your personal messages to save your number. Just learn ok. That would be all for today. I would give us more information tomorrow. In the mean time, remember that:</p><br />
                  <h5>Laptop Users</h5>
                  <p>Photoshop</p>
                  <p>CorelDraw</p>

                  <h5>Smartphone Users</h5>
                  <p>Canva</p>
                  <p>Pixellab</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={canvaImg} alt="example Img"/>
                    <img src={pixellabImg} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  
                  <p>You Can download Photoshop & CorelDraw from</p>
                  <p><a href='https://filecr.com' rel="noreferrer" target='_blank'>Filecr</a></p>
                  <p><a href='https://getintopc.com' rel="noreferrer" target='_blank'>Getintopc</a></p>
                  
                  <h5>Don't forget to Like and Follow Us on our social handles:</h5>
                  <div className="social-icon">
                    <a href="https://www.linkedin.com/company/totlesoft/"><img src={navIcon1} alt="Icon" /></a>
                    <a href="https://www.facebook.com/totlesoft/"><img src={navIcon2} alt="Icon" /></a>
                    <a href="https://www.instagram.com/totlesoft/"><img src={navIcon3} alt="Icon" /></a>
                  </div>
                  <br /><br />
                  <p>Also share the link with your friends. Thanks.</p>
                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />



                  


                  <p>
                  Good Evening... Please get prepared. We wil be Starting in an hour.<br /><br />
                  Are you getting set? ... We will be starting in 30 min.
                  </p><br />

                  <h5 className="chris">Class Begins (DAY TWO)</h5>
                  <p>Good evening great minds and welcome to day two of our training, glad you could join us in this training. My name remain Christotle Agholor and by His grace I wil be taking you on this class.</p><br />
                  <p>I am a Graphics Designer, Full Stack Web/Mobile App Developer and a Design Coach.</p><br />
                  
                  <p>Today we would talk more on design fundamentals.</p><br />
                  <h5>Find bellow some files on Design Principles:</h5><br />

                  <h5>* Alignment As A Principle of Design</h5>
                  <p>Link to Google Drive comes here</p><br />

                  <h5>* Hierarchy As A Principle of Design</h5>
                  <p>Link to Google Drive comes here</p><br />

                  <h5>* Balance As A Principle of Design</h5>
                  <p>Link to Google Drive comes here</p><br />

                  <h5>* Contrast As A Principle of Design</h5>
                  <p>Link to Google Drive comes here</p><br />

                  <h5>You can also read these books on Design Elements and Principles Here</h5>
                  <h3>Books on Design</h3>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1T_7rMZR6Ie-P4ASxnETpEv54JQndDG6F' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1T_7rMZR6Ie-P4ASxnETpEv54JQndDG6F</a></p><br />

                  <h5>Today I would emphasize more on *Typography*</h5>
                  <p>For you to be able to use fonts well, you need to understand what typography is all about. Today we will learn the Dos and Don't of typography.</p><br />
                  <p>Then after the class I would send videos on introduction to</p>
                  <p>* Photoshop</p>
                  <p>* CorelDraw</p>
                  <p>* Canva</p>
                  <p>* Pixellab</p><br />

                  <h3>1. What is Typography?</h3>
                  <p>Typography is the art of arranging letters and in a way that makes them clear, and visually appealing to the reader.</p><br />
                  <p>Typography involves fonts, font styles, structures, and appearances.</p><br />
                  <p>With Typography, you can create the right kind of emotion and feeling you want the reader to have *based on the aim or function of the design*</p><br />

                  <h3>2. Importance of Typography</h3>
                  <p>If you want your design to stand out and pass the message you want, then you have to learn about typography.</p><br />
                  <p>With typography, you can guide the reader.</p><br />

                  <h3>3. Elements of Typography</h3>
                  <p>Typography is divided into</p>
                  <p>🔰 Typeface, and</p>
                  <p>🔰 Fonts</p>
                  <p>*Typeface* refers to the entire font family, While *Font* refers to a single member of the family.</p><br />
                  <p>In other words, see typeface as humans and then fonts as either a male or a female.</p><br />

                  <h3>4. Types of Fonts</h3>
                  <h5>* Serif font:</h5>
                  <p>Serif fonts are fonts with extra feet at the top and bottom of each letter called serif </p>

                  <h5>* Sans-Serif fonts:</h5>
                  <p>These are fonts without serif. Sans-Serif typefaces do not include any projections at the end of the strokes of its letterforms.</p>

                  <h5>* Script Fonts</h5>
                  <p>These are decorative and stylish fonts. They are based on the fluid strokes of handwriting, and can range from formal to very casual.</p>
                  <p>I. Formal Scripts (Flowing loops and flourishes)</p>
                  <p>II. Casual Scripts (A brush-like appearance with stronger strokes).</p>
                  <p>III. Calligraphic Scripts (Emulate hand-lettered calligraphy).</p>
                  <p>IV. Blackletter Scripts (Very formal, strong contrast on strokes).</p>
                  <p>V. Handwriting Scripts (Very casual. Mimic modern handwriting).</p>

                  <h5>* Monospaced Fonts</h5>
                  <p>These are fonts that are non-proportional - every letter takes up the same amount of horizontal space on the page or screen.</p>

                  <h5>* Display Fonts</h5>
                  <p>They are vary widely in their appearance, and include both practical and novelty fonts suitable for headlines and titles.</p>
                  <br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={fontImage1} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={fontImage2} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h3>5. Choosing Fonts for Your Designs</h3>
                  <p>When it comes to selecting fonts you need to take note of some things.</p>
                  <p>* Understand the aim of the design.</p>
                  <p>* Know that every font cannot be used for a design</p>
                  <p>* Use at most 3 fonts anything more than that is too much. (If you can stick to just 2 fonts)</p>
                  <p>* Have option. Gather as many fonts as possible, so you have options to choose from.</p>
                  <p>* Practice. Practice again. and practice again and again.</p><br />

                  <h3>6. Sites to download fonts from</h3>
                  <p><a href='https://dafont.com' rel="noreferrer" target='_blank'>www.dafont.com</a></p>
                  <p><a href='https://fontsquirrel.com' rel="noreferrer" target='_blank'>www.fontsquirrel.com</a></p>
                  <p><a href='https://fontspace.com' rel="noreferrer" target='_blank'>www.fontspace.com</a></p>
                  <p><a href='https://fontesk.com' rel="noreferrer" target='_blank'>www.fontesk.com</a></p>
                  <p><a href='https://fontzone.net' rel="noreferrer" target='_blank'>www.fontzone.net</a></p><br />

                  <h3>How to download and install Fonts into your Laptop or your Smartphone</h3>
                  <p>Totlesoft Media have some videos on how you can download and install fonts. WATCH BELLOW:</p><br />

                  <h5>Videos on How to Install Font on Your PC and Smartphone</h5>
                  <p><a href='https://drive.google.com/drive/u/1/folders/11L6CICBSHFdgCnywM42NnBf3tzOqc3jo' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/11L6CICBSHFdgCnywM42NnBf3tzOqc3jo</a></p><br />
                  
                  <h3>Practical Videos: Introduction To Design Tools:</h3>
                  <p>TGA also have videos on introduction to:</p>
                  <p>* Photoshop</p>
                  <p>* CorelDraw</p>
                  <p>* Canva</p>
                  <p>* Pixellab</p><br />

                  <h5>Find Videos Bellow:</h5>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1FtSLa8JpetI1W11Q7WK1aNhf71mgF7vT' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1FtSLa8JpetI1W11Q7WK1aNhf71mgF7vT</a></p><br />
                  
                  <h3>First Asisgnment Will Be Coming Up Tomorrow</h3>
                  <p>For now, get your design tools ready and read some documents to be ahead for deeper understanding and excellence.</p>
                  <p>NOTE: We may all start at the same time, but before the end of this training, some of you would have already been ahead of others by extra work. HOPE YOU WILL BE AMONG THAT CATIGORY?</p><br />

                  <p>You Can download Photoshop & CorelDraw from</p>
                  <p><a href='https://filecr.com' rel="noreferrer" target='_blank'>Filecr</a></p>
                  <p><a href='https://getintopc.com' rel="noreferrer" target='_blank'>Getintopc</a></p><br />
                  
                  <h5>Don't forget to Like and Follow Us on our social handles:</h5>
                  <div className="social-icon">
                    <a href="https://www.linkedin.com/company/totlesoft/"><img src={navIcon1} alt="Icon" /></a>
                    <a href="https://www.facebook.com/totlesoft/"><img src={navIcon2} alt="Icon" /></a>
                    <a href="https://www.instagram.com/totlesoft/"><img src={navIcon3} alt="Icon" /></a>
                  </div>
                  <br /><br />
                  <p>Also share the link with your friends. Thanks.</p>
                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />






                  <p>
                  Good Evening... Please get prepared. We wil be Starting in an hour.<br /><br />
                  Are you getting set? ... We will be starting in 30 min.
                  </p><br />

                  <h5 className="chris">Class Begins (DAY THREE)</h5>
                  <p>Good evening great minds and welcome to day three of our training, glad you could join us in this training. My name remain Christotle Agholor and by His grace I wil be taking you on this class.</p><br />
                  <p>I am a Graphics Designer, Full Stack Web/Mobile App Developer and a Design Coach.</p><br />
                  
                  <p>So far we have talked about a lot of things:</p><br />
                  <p>🔰 Design Fundamentals</p>
                  <p>🔰 Introduction to design tools</p>
                  <p>🔰 Typography</p><br />

                  <h3>Today's lesson will be on</h3>
                  <p>🔰 Colors</p><br />
                  <p>As said yesterday, after today's class, I would send us practical videos on *Assignment 1*.</p><br />

                  <h3>Colors</h3>
                  <p>Color is one of the elements of design that you will always use.</p>
                  <p>It adds beauty and causes attention. Notwithstanding, if you fail to use color well, it can cause a disaster in your design.</p>
                  <p>NOTE: You would not know how to combine colors overnight... it takes practices to become perfect. You need to be patient with yourself and practice. The more you learn the better it gets.</p><br />

                  <h3>1. What is Color theory</h3>
                  <p>Color theory refers to the understanding of how best to use and combine colors for better communication.</p>
                  <p>The beauty of colors is felt when they are combined well</p>
                  <p>Remember the information available to you would determine how creative you can get</p><br />

                  <h3>2. Types of color modes</h3>
                  <p>Color mode is simply a way we describe the colors in a color system</p>
                  <p>There are different types of color modes, e.g. RGB Mode (Millions of colors), CYMK Mode (Four-printed colors), Index Mode (256 colors), Grayscale Mode (256 grays), Bitmap Mode (2 colors). But for the sake of this class, we would stick to just two</p>
                  <p>🔰 RGB</p>
                  <p>🔰 CMYK</p>

                  <p>*RGB* - Red, Green, and Blue (This color mode is best for designs that are meant for just social media).</p>
                  <p>*CMYK* - Cyan, Magenta, Yellow, and Key (This is a color mode used for designs that are print purposes).</p>

                  <h3>3. Types of Colors in a color wheel</h3>
                  <p>There are two types of colors in the color wheel.</p>
                  <p>🔰 Warm colors</p>
                  <p>🔰 Cool Colors</p>
                  
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={colorwheelImage} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <p>Humans are naturally attracted to warm colors. Therefore you can use that to create more attention to specific areas in your design.</p><br />

                  <h3>4. Tips on how to combine colors better</h3>
                  <p>🔰 Learn more about color theory</p>
                  <p>🔰 Use color wheels and palettes</p>
                  <p>🔰 Learn and practice how to combine colors better</p>
                  <p>🔰 Learn from other designers that are good with colors</p>
                  <p>🔰 Learn and pay attention more to the meaning of colors</p>
                  <p>🔰 Keep your color combination simple. *Don't use too many colors*</p><br />
                  <p>I would be sending you links to access videos for the practical assignments now.</p><br />

                  <h3>Assignment 1</h3>
                  <p>* If you are using a smartphone to do the assignments use Pixellab and Canva</p>
                  <p>* If you are using a laptop to do the assignments use Photoshop and CorelDraw</p>
                  <br />



                  <h3>Pixellab Assignment 1</h3>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={assignMent1Img1} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h5>Click the link bellow to download the videos on how to do the assignment</h5>
                  <p>The link also contains the resources used.</p>
                  <p>You are expected to do exactly what is there or something better and not lesser.</p>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1fnsuSdeu_7pK_wxZBpsV5vGLf7AIks5f' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1fnsuSdeu_7pK_wxZBpsV5vGLf7AIks5f</a></p><br />
                  

                  <h3>Canva Assignment 1</h3>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={assignMent1Img2} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h5>Click the link bellow to download the videos on how to do the assignment</h5>
                  <p>The link also contains the resources used.</p>
                  <p>You are expected to do exactly what is there or something better and not lesser.</p>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1ku3pGd8n8E6mA9nI4gf3gh65nmTj8sV7' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1ku3pGd8n8E6mA9nI4gf3gh65nmTj8sV7</a></p><br />


                  <h3>Photoshop Assignment 1</h3>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={assignMent1Img3} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h5>Click the link bellow to download the videos on how to do the assignment</h5>
                  <p>The link also contains the resources used.</p>
                  <p>You are expected to do exactly what is there or something better and not lesser.</p>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1ZAiSRIFwXsIW5ybkHobDWyxpLRsQksku' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1ZAiSRIFwXsIW5ybkHobDWyxpLRsQksku</a></p><br />


                  <h3>CorelDraw Assignment 1</h3>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={assignMent1Img4} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h5>Click the link bellow to download the videos on how to do the assignment</h5>
                  <p>The link also contains the resources used.</p>
                  <p>You are expected to do exactly what is there or something better and not lesser.</p>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1FVYq8SAf6eFZHcOytU-qRlkPi6H9sVG-' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1FVYq8SAf6eFZHcOytU-qRlkPi6H9sVG-</a></p><br />

                  <h3>PLEASE NOTE:</h3>
                  <p>1. If you don't see the exact Icon that was used for the pixellab assignment, you can use another one</p>
                  <p>2. You are to design exactly the same thing for the assignment related to you.</p>
                  <p>3. If you can't click the links, kindly save our number</p>
                  <p>You can submit your assignment to the link bellow: </p>
                  <p>Link to our Telegram Group Channel...https://t.me/+_rFh5PBbL0dkNDVk</p>
                  <p>Assignment must be submitted on or before Sunday</p>

                  <h5>Don't forget to Like and Follow Us on our social handles:</h5>
                  <div className="social-icon">
                    <a href="https://www.linkedin.com/company/totlesoft/"><img src={navIcon1} alt="Icon" /></a>
                    <a href="https://www.facebook.com/totlesoft/"><img src={navIcon2} alt="Icon" /></a>
                    <a href="https://www.instagram.com/totlesoft/"><img src={navIcon3} alt="Icon" /></a>
                  </div>
                  <br /><br />
                  <p>Also share the link with your friends. Thanks.</p>
                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />

                  



                  <p>
                  Good Evening... Please get prepared. We wil be Starting in an hour.<br /><br />
                  Are you getting set? ... We will be starting in 30 min.
                  </p><br />

                  <h5 className="chris">Class Begins (DAY FOUR)</h5>
                  <p>Good evening great minds and welcome to day four of our training, glad you could join us in this training. My name remain Christotle Agholor and by His grace I wil be taking you on this class.</p><br />
                  <p>I am a Graphics Designer, Full Stack Web/Mobile App Developer and a Design Coach.</p><br />

                  <p>So far we have talked about a lot of things:</p><br />
                  <p>🔰 Design Fundamentals</p>
                  <p>🔰 Introduction to design tools</p>
                  <p>🔰 Typography</p>
                  <p>🔰 Colors</p><br />

                  <h3>Today's lesson will be on</h3>
                  <p>🔰 Mistakes to avoid as a graphic designer.</p><br />
                  
                  <p>Today I would share with us, some mistakes to avoid as a graphic designer.</p>
                  <p>Whether you’re a brand new designer looking to jump into your first order or you’re an old hand who’s looking for a refresher, these common graphic design mistakes can ambush any designer and potentially cause a lot of harm.</p><br />
                  
                  <h5> 🔰 Not paying attention to Instructions</h5>
                  <p>Communication between the designer and the client is critical. Try as much as you can to pay keen attention to instructions and the client's request.</p>
                  <p>Most of the time, designers want to show the client that they are the professionals and they end up not understand in full details what the client wants.</p><br />

                  <h5>🔰 Being too loud with fonts</h5>
                  <p>It would be better to stick to just one, or maybe two fonts. A single font adds continuity, which is good.</p>
                  <p>Playing with fonts may be fun, but if someone is trying to read through something that changes font type ten times in a paragraph, it’ll get tiring and annoying quickly.</p>
                  <p>Using all the fonts you have doesn't make you the best designer.</p><br />

                  <h5>🔰 Worrying about perfection</h5>
                  <p>Just because you can add something to your design doesn’t mean you should. Simplicity has plenty of perks on its own. So, be careful about going crazy with the Photoshop filters.</p>
                  <p>Over-designing isn’t a major mistake, but it can cause some serious problems. Simple is beautiful.</p>
                  <p>The more stuff in your design, the harder a viewer needs to think to extract the info.</p><br />

                  <h5>🔰 Not delivering as promised</h5>
                  <p>Always make sure you give more than you promised, not less than you promised. This can ruin your reputation and design career</p>
                  <p>* Do not make loud promises that arise their expectation to a very high level only to disappoint them.</p>
                  <p>* So when discussing deadlines and expectations with your client, you’ll want to make sure you don’t promise them something amazing, and then fail to meet that promise. It’s better to finish a project ahead of a long deadline than late on a short deadline.</p><br />

                  <h5>🔰 Spelling and Grammar Errors</h5>
                  <p>We are all guilty of this, including myself</p>
                  <p>Yes, you are a graphic designer and not a writer, but that doesn’t give you an excuse to pass on proper spelling.</p>
                  <p>While you may feel that running a quick spell check after finishing your project is all you’ll need, there are plenty of graphic design mistakes that spell check systems can miss.</p>
                  <p>Along with spelling problems, you want to make sure your project has proper grammar.</p>
                  <p>While a misused comma or other punctuation marks may not seem like a major problem, there are plenty of people out there that will see a small slip like that and disregard the entire rest of the project.</p><br />

                  <h5>🔰 Designing to please yourself</h5>
                  <p>We are all tempted to want to please ourselves with our designs. But as a good graphic designer that understands value, I would advise you do this instead:</p>
                  <p>* When you have a project, listen to the client and advise them.</p>
                  <p>* If you don't feel comfortable with their request, please you can walk away to protect your reputation. This is the bitter truth but I had to say it.</p>
                  <p>* Try not to force your personality or personal interest into the business.</p><br />

                  <h5>That will be all for today. But before we go here is the link to the Assignment 1. Please do them and more at your free time.</h5>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1HnenTD6niukVHYFVrEUSf8jtYbY5rOfc' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1HnenTD6niukVHYFVrEUSf8jtYbY5rOfc</a></p><br />
                  <h5>Our Next Set of Assignment will be coming up tomorrow. Please be prepared. Practice, and keep practicing.</h5>


                  <h5>Don't forget to Like and Follow Us on our social handles:</h5>
                  <div className="social-icon">
                    <a href="https://www.linkedin.com/company/totlesoft/"><img src={navIcon1} alt="Icon" /></a>
                    <a href="https://www.facebook.com/totlesoft/"><img src={navIcon2} alt="Icon" /></a>
                    <a href="https://www.instagram.com/totlesoft/"><img src={navIcon3} alt="Icon" /></a>
                  </div>
                  <br /><br />
                  <p>Also share the link with your friends. Thanks.</p>
                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />

                  



                  <p>
                  Good Evening... Please get prepared. We wil be Starting in an hour.<br /><br />
                  Are you getting set? ... We will be starting in 30 min.
                  </p><br />

                  <h5 className="chris">Class Begins (DAY FIVE)</h5>
                  <p>Good evening great minds and welcome to day five of our training, glad you could join us in this training. My name remain Christotle Agholor and by His grace I wil be taking you on this class.</p><br />
                  <p>I am a Graphics Designer, Full Stack Web/Mobile App Developer and a Design Coach.</p><br />

                  <p>So far we have talked about a lot of things:</p><br />
                  <p>🔰 Design Fundamentals</p>
                  <p>🔰 Introduction to design tools</p>
                  <p>🔰 Typography</p>
                  <p>🔰 Colors</p>
                  <p>🔰 Mistakes to avoid as a graphic designer.</p><br />

                  <h3>Today will be for another assignment.</h3>
                  <p>Also, I would send you some links to our YouTube live events. They would be of great help to you. Go through each if you can and equip yourself for the big things comming your way soon.</p><br />
                  
                  <p>We organized a 7 days free monetization summit for graphics designers and bellow are links to the replay:</p><br />

                  <h5> *7 Stages to Monetize any niche as a graphic designer* </h5>
                  <p>https://youtu.be/zoFWs74JqX8</p><br />

                  <h5>*How to monetize your skill with digital products* </h5>
                  <p>https://youtu.be/JjhG6etZAaQ</p><br />

                  <h5>*How to acquire new clients and keep old ones* </h5>
                  <p>https://youtu.be/rLdEsK7lshk</p><br />

                  <h5> *Smartphone Monetization Secrets*</h5>
                  <p>https://youtu.be/AOb42GF_mA0</p><br />

                  <h5> *How to build a strong personal brand* </h5>
                  <p>https://youtu.be/4H0okBzn0Qk</p><br />


                  <h3>Assignment 2</h3>
                  <p>* If you are using a smartphone to do the assignments use Pixellab and Canva</p>
                  <p>* If you are using a laptop to do the assignments use Photoshop and CorelDraw</p>
                  <br />



                  <h3>Photoshop Assignment 2</h3>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={assign2Img1} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h5>Click the link bellow to download the videos on how to do the assignment</h5>
                  <p>The link also contains the resources used.</p>
                  <p>You are expected to do exactly what is there or something better and not lesser.</p>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1HtCGqChuwS6EZmrmH8kQq5-Zb3U9Bv_V' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1HtCGqChuwS6EZmrmH8kQq5-Zb3U9Bv_V</a></p><br />


                  <h3>CorelDraw Assignment 2</h3>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={assign2Img2} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h5>Click the link bellow to download the videos on how to do the assignment</h5>
                  <p>The link also contains the resources used.</p>
                  <p>You are expected to do exactly what is there or something better and not lesser.</p>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1fwBtKNk63FrkMIyxdvoyKFYstR5F0psc' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1fwBtKNk63FrkMIyxdvoyKFYstR5F0psc</a></p><br />


                  <h3>Canva Assignment 2</h3>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={assign2Img3} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h5>Click the link bellow to download the videos on how to do the assignment</h5>
                  <p>The link also contains the resources used.</p>
                  <p>You are expected to do exactly what is there or something better and not lesser.</p>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1yhIL2yJs7Um8hMpvoLmeIOydzgo7Yr5m' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1yhIL2yJs7Um8hMpvoLmeIOydzgo7Yr5m</a></p><br />


                  <h3>Pixellab Assignment 2</h3>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={assign2Img4} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h5>Click the link bellow to download the videos on how to do the assignment</h5>
                  <p>The link also contains the resources used.</p>
                  <p>You are expected to do exactly what is there or something better and not lesser.</p>
                  <p><a href='https://drive.google.com/drive/u/1/folders/1rbWAk96sRk0fUFNm9FikXHkF9lGJUtql' rel="noreferrer" target='_blank'>https://drive.google.com/drive/u/1/folders/1rbWAk96sRk0fUFNm9FikXHkF9lGJUtql</a></p><br />

                  <h5>This training ends in 2day's time.</h5>
                  <p>So, tomorrow is our Question and Answers day.</p>
                  <p>Send your questions on graphic design to the telegram group using this heading:</p><br />
                  <p>*My Question*</p>
                  <p>Then followed by your question</p><br />

                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />

                  






                  <p>
                  Good Evening... Please get prepared. We wil be Starting in an hour.<br /><br />
                  Are you getting set? ... We will be starting in 30 min.
                  </p><br />

                  <h5 className="chris">Class Begins (DAY SIX)</h5>
                  <p>Good evening great minds and welcome to day six of our training, glad you are still with us all the way. My name remain Christotle Agholor.</p><br />
                  <br />

                  <p>So far we have talked about a lot of things:</p><br />
                  <p>🔰 Design Fundamentals</p>
                  <p>🔰 Introduction to design tools</p>
                  <p>🔰 Typography</p>
                  <p>🔰 Colors</p>
                  <p>🔰 Mistakes to avoid as a graphic designer.</p>
                  <p>🔰 Two Assignment Sessions.</p>
                  <p>I know we have been learning and I believe you're going to be a suprise to yourself soon. Please remember, no matter what you're taught, if you don't do your own personal studies you will be limiting yourself. Standing on the shoulders of others helps you see further. Develop yourself daily and soon you will be unstopable.</p><br />

                  <h3>Welcome once again. Today, I would talk about types of graphic design.</h3>
                  <p>As for those just joining us, I will re-share the links to both assignments. Stay Focus.</p>
                  <p>Lets begin.</p><br />

                  <h3>Types of Graphics Designs</h3><br />

                  <h5>1. Visual Identity Graphic Design</h5>
                  <p>Visual identity design is one of the most common types of design.</p>
                  <p>Visual identity graphic designers must possess a general knowledge of all types of graphic design in order to create design elements that are suitable across all visual media.</p>
                  <p>They also need excellent communication, conceptual and creative skills, and a passion for researching industries, organizations, trends and competitors.</p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={designImg1} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>2. Marketing and Advertising Graphic Designers</h5>
                  <p>Designers can specialize in a specific type of media (vehicle wraps or magazine ads, for example) or create a broad assortment of collateral for print, digital, and beyond.</p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={designImg2} alt="example Img"/>
                    <img src={designImg2b} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>3. UI Graphic Designer</h5>
                  <p>UI designers specialize in desktop apps, mobile apps, web apps, and games. They work closely with UX (user experience) designers (who determine how the app works) and UI developers (who write code to make it work).</p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={designImg3} alt="example Img"/>
                    <img src={designImg3b} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>4. Publication Graphic Designer</h5>
                  <p>Publication designers must possess excellent communication, layout and organizational skills.</p>
                  <p>In addition to graphic design expertise, they need to understand color management, printing and digital publishing.</p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={designImg4} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>5. Packaging Graphic Designers</h5>
                  <p>Packaging designers create concepts, develop mockups and create the print-ready files for a product.</p>
                  <p>This requires expert knowledge of print processes and a keen understanding of industrial design and manufacturing. Because packaging design touches so many disciplines, it’s not uncommon for designers to find themselves creating other assets for a product such as photography, illustrations and visual identity.</p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={designImg5} alt="example Img"/>
                    <img src={designImg5b} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>6. Motion Graphic Designers</h5>
                  <p>Motion graphics designer” is a somewhat new specialty for designers. Formally reserved for TV and film, technological advances have reduced production time and costs, making the art form more accessible and affordable.</p>
                  <p>Now, motion graphics is one of the newest types of design and can be found across all digital platforms, which has created all sorts of new areas and opportunities.</p><br />

                  <p>Gif</p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={designImg6b} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <p>MP4</p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <video src={designvid6} type="video/mp4" muted="true" autoPlay="true" controls="controls" width="100%"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>7. Environmental Graphic Design</h5>
                  <p>Environmental graphic design is a multidisciplinary practice that merges graphic, architectural, interior, landscape and industrial design.</p>
                  <p>Designers collaborate with people in any number of these fields to plan and implement their designs.</p>
                  <p>Because of that, designers typically have education and experience in both graphic design and architecture.</p>
                  <p>They must be familiar with industrial design concepts and able to read and sketch architectural plans.</p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={designImg7} alt="example Img"/>
                    <img src={designImg7b} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>8. Art & Illustration for graphic design</h5>
                  <p>Graphic artists use any combination of media and techniques to create their work as they collaborate with writers, editors, managers, marketers and art directors across all graphic design types. They’ll often have a foundation in fine arts, animation or architecture.</p>
                  <p>Overlapping skills and apps make it possible to find graphic designers who also work as graphic artists and illustrators (and vice versa).</p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={designImg8} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>This training ends tomorrow.</h5>
                  <p>So, tomorrow is our Question and Answer day.</p>
                  <p>Send your questions on graphic design to the telegram group using this heading:</p><br />
                  <p>*My Question*</p>
                  <p>Then followed by your question</p>
                  <p>I will give you some resource for free by tomorrow. Do well to be available and come prepare.</p>
                  <h6>You can submit your assignments via the Telegram Cannel here</h6>
                  <p>telegram link 6768905-0-0-ujnfnnu</p><br />

                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />






                  <p>
                  Good Evening... Please get prepared. We wil be Starting in an hour.<br /><br />
                  Are you getting set? ... We will be starting in 30 min.
                  </p><br />

                  <h5 className="chris">Class Begins (DAY SEVEN)</h5>
                  <p>Good evening great minds and welcome to the seventh and last day of our training, glad you were able to make it to the end of the training. My name remain Christotle Agholor.</p><br />
                  <br />

                  <p>In the last Six days we have talked about a lot of things:</p><br />
                  <p>🔰 Design Fundamentals</p>
                  <p>🔰 Introduction to design tools</p>
                  <p>🔰 Typography</p>
                  <p>🔰 Colors</p>
                  <p>🔰 Mistakes to avoid as a graphic designer.</p>
                  <p>🔰 Types of graphic design</p>
                  <p>🔰 We had two Assignment Sessions also.</p>
                  <p>I know we have learnt alot no doubt. Today we will be answering some of your questions or all if time permit.</p>
                  <p>NOTE: Though the training ends today but you can still send in your questions by reaching me on my social media handles. You can save my number and whatsapp me directly and I will be glad to help you in any way I can</p><br />

                  <h3>Welcome once again. Today, like I said, I will be answering your questions but before then...</h3><br />
                  <h5>Here are some design resource for you... all for free!</h5><br />

                  <h5>Design Resources</h5>
                  <p>https://drive.google.com/folderview?id=1c1sclfsU1ayALLRypgy5IORrJb1vRyB7</p><br />

                  <h5>5 premium mockups</h5>
                  <p>https://drive.google.com/folderview?id=1B4rtJJlipY9syYVnUR89R_weQG43Z9Qj</p><br />

                  <h5>Books</h5>
                  <p>https://drive.google.com/folderview?id=1ufoE9BNkAgX2qke2GisSd2mKp3ABkH4e</p><br />

                  <p>Please do well to take advantage of them and you will be glad you did.</p>
                  <p>As for those who joined us late, I will re-share the links to both assignments to ensure everyone benefits accordingly.</p>
                  <p>SOON, WE WILL BE SWITCHING OVER TO OUR TELEGRAM CHANNEL TO ANSWERING YOUR QUESTIONS...</p><br />

                  <p>But before then, it is important for us to know that, all we have done in this 7 Days Biginners Class is simply an introduction to Graphic Design as a Career.</p>
                  <p>And as expected in succeeding in any thing, you would need more than just the fundamentals.</p>
                  <h6>Master Graphic Design From A-Z Even if You are a Complete Beginner</h6>
                  <p>For taking out time to join us in this 7 days, It will be our joy to see you succeed in this great career path, and that's why I would want you to enrole in our Master Class coming up soon. Registration is currently open and will be ending soon.</p>
                  <p>We have a number we enrole so we can give everyone maximum attention. So hurry and join others already registered and get your access too.</p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={masterClassImg} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <p>Learning a skill has now become way easier with this one and only Online course that provides you with the needed environment, materials, and mentorship you need to not just learn one of the most profitable skills, but also ensures you master and make money from it.</p>
                  <p>Before you miss out on this once in a lifetime opportunity so many graphic designers have enjoyed, hear me out.</p>
                  <p>Totlesoft Graphic Academy (TGA) is the most resourceful graphic design online course that helps you learn effectively in no time the theories, practicals and best practices in graphic design that can turn you into a professional in 30 days or less.</p>
                  
                  <h3>A. What will I benefit from this training?</h3><br />
                  <p>If you learn and practise all you would be taught in this 30 days course, you would be able to do the following without stress or any wasting of time.</p>
                  <p>💡 Understand the fundamentals and principles of graphic design. You would be able to know how to use the elements of design effectively.</p>
                  <p>💡 You will learn the secret on how to get *the best resources for your design projects.* </p>
                  <p>💡 How to come up with *creative ideas for your designs.* </p>
                  <p>💡 How to design with your *laptop using Photoshop and CorelDraw.*</p>
                  <p>💡 How to design with your *smartphone using Canva and Pixellab.*</p>
                  <p>💡 How to design *Logos, Flyers, Business Cards, Mockups, 3D logos, etc, using your Laptop or Smartphone.* </p>
                  <p>💡 *How to make money* from your skill as a graphic designer.</p>
                  <p>💡 How to become *more productive and do more with less time and effort.* </p>
                  <p>💡 How to grow a *profitable personal brand* as a graphic designer.</p>
                  <p>💡 *Top skills you need to know as a graphic designer* such as (Social Media, Content Creation, Freelancing, Sales, Marketing, etc)</p><br />

                  <h3>B. Why should I choose your course over others?</h3><br />
                  <p>You may have tried to learn graphic design online before in the past and it didn’t turn out well… It's not your fault.</p>
                  <p>That’s because all other graphic design courses are more concerned about teaching you how to use the latest design Software or Apps without ensuring you go through the required process and steps to start from the very beginning and walk you through to the top.</p>
                  <p>The Totlesoft Graphic Academy (TGA) you are about to be a part of is not the same. This is totally different.</p>
                  <p>This course is all about you and how you can succeed as a graphic designer.</p><br />

                  <h3>C. What is included in this package?:</h3><br />
                  <p>💡 24 practical assignments</p>
                  <p>💡 10 WhatsApp Sessions </p>
                  <p>💡 3 Live Sessions</p>
                  <p>💡 30K+ Design Resources</p>
                  <p>💡 Creativity Books on Graphic Design</p>
                  <p>💡 Certificate of Completion</p>
                  <p>💡 2 Month Mentorship</p>
                  <p>And a lot more</p>

                  <h3>D. What design tools are we using?</h3><br />
                  <p>The course is a 2 in 1 class</p>
                  <p>For those who own a laptop, and want to learn using it, you would learn how to design using Photoshop and CorelDraw</p>
                  <p>For those who own a smartphone, and want to learn using it, you would learn how to design using Pixellab and Canva</p><br />

                  <h3>E. How do I know this is real?</h3>
                  <p>We have successfully taught 2230+ students in this Academy, and over 8,000 students in other courses both paid and free</p>
                  <p>In Totlesoft Graphic Academy, you will learn the exact systems, formulas, and procedures you can use in becoming a voice in the design industry.</p>
                  <p>There are three faculties in Totlesoft Graphic Academy you would go through</p>
                  <p>🔰 Faculty of Personal Development</p>
                  <p>🔰 Faculty of Creativity </p>
                  <p>🔰 Faculty of Business</p><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={advanceDesignGifImg} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h3>F. Why Should I Join This Course Now</h3><br />
                  <p>You should join this course now because this singular action is about to change your life and finances forever by ensuring you learn a very profitable skill. </p>
                  <p>NOTE: There are limited slots.</p>
                  <p>Only those who get into this current batch early would get a great deal.</p>
                  <p>Most people would be left out. But I pray you won't. So, I urge you to get it right now…</p><br />

                  <h3>G. Package Bonus</h3><br />
                  <p>Only those who register within the time limit would get the following as bonuses:</p>
                  <p>🔰 Bonus 1: Typography Manual</p>
                  <p>🔰 Bonus 2: Color Theory Guide</p>
                  <p>🔰 Bonus 3: Introduction to Graphic Design</p>
                  <p>🔰 Bonus 4: Monetization Toolkit</p>
                  <p>🔰 Bonus 5: 20K+ Graphic Design Resources</p>
                  <p>🔰 Bonus 6: 10 Must-Read Books For all Creative Minds</p>
                  <p>🔰 Bonus 7: Upwork and Fiverr Account Opening Guides</p>
                  <p>🔰 Bonus 8: WhatsApp Automation Hacks</p>
                  <p>This academy is so loaded and impactful to the extent we could charge you N50,000 to register for it. But we won't 😊</p>
                  <p>The registration fee is N30,000.</p>
                  <p>We are offering you an opportunity to liberate yourself and become financially free</p>
                  <p>Relax! You would not be paying N50,000 because you came at this time of our discount offers.</p>
                  <p>The Early bird's fee is N20,000</p>
                  <p>But...</p>
                  <p>We want to allow 100 people to register for this batch of TGA with just N5000 between the time stated in the offer ad.</p>
                  <p>After the offer time elapse, the price increases to N20,000 and you will lose out of all the bonuses.</p>
                  <p> If I was you I would not wait till then. I would register now!</p>
                  <p>I once took advantage of an opportunity like this, and it has paid me more than I could have ever imagined.</p><br />

                  <h3>H. Why should I trust you and what if I don’t get all you promised?</h3><br />
                  <p>With almost a decade of experience in graphic design, we have seen and made lots of mistakes in this career path, and these mistakes are what we do not want you to make.</p>
                  <p>If at the end of 30 days of teaching and practice, you don't get all we promised and many more, be rest assured you will get a refund and an apology letter from us.</p><br />

                  <h3>I. Here is why you should register now</h3>
                  <p>💡 Only those who register early would gain access to all the bonuses listed above in this course.</p>
                  <p>💡 We have a special gift worth N20,000 for the first 20 persons who register for this course.</p>
                  <h5>See all you want to miss out of:</h5><br />
                  <p>1. 30 days graphic design class.</p>
                  <p>2. Download on-demand custom made practical graphic design videos.</p>
                  <p>3. Weekly theoretical and creative mind sessions.</p>
                  <p>4. 20,000+ Downloadable graphic design resources.</p>
                  <p>5. Full lifetime access to materials.</p>
                  <p>6. Course is available to both Smartphone and Laptop users.</p>
                  <p>7. Certificate of Completion.</p>
                  <p>8. 2-Months Mentorship</p>
                  <p>9. Opportunity to win N10,000 Cash Prize and lots of Gifts</p><br />
                  

                  <Nav.Link href='https://selar.co/dqt4' rel="noreferrer" target='_blank'><h3>PAY - REGISTER HERE</h3></Nav.Link><br />

                  <h5 className="chris">Suported Currencies</h5>
                  <p>NGN, USD, GBP, GHS, KES, ZAR, TZS, UGX, XAF, XOF, RWF</p><br />
                  
                  <h5 className="chris">Payment Options</h5>
                  <p>Bank, Bank Transfer, Visa/Master Card, USSD</p><br />

                  <h5 className="chris">Crypto Currency & Payoneer</h5>
                  <p>Please contact us for directions: https://totlesoft/#connect</p><br />

                  <Nav.Link href='https://selar.co/dqt4' rel="noreferrer" target='_blank'><h3>PAY - REGISTER HERE</h3></Nav.Link><br />

                  <p>If after making the payment you did not hear from us in 2 hours, please send prove of payment to our WhatsApp so you can be added to the Student List.</p>
                  <p className="chris"><a href="https://wa.me/2347064931387">WhatsApp Link</a></p><br />

                  <h5>Act Now!</h5> 
                  
                 <button>Checkout Our Advance Courses Here: <ArrowRightCircle size={25} /></button>
                 <Nav.Link href="/academy"><h5>* Advance Graphics Design Training</h5></Nav.Link><br />












                 <p>*************</p><br />



                 <h2>END OF BEGINNERS CLASS AND BEGINNING OF MASTER CLASS </h2><br />



                 <p>*************</p><br />






                <h1>30 Days Master Class <span className='quoteHeader'>Graphics Design 201</span> Advance Training.</h1>
                <h4>Instructor: Christotle Agholor</h4><br />
                
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={masterClassImg} alt="Header Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <p>
                  Congratulations for making it to this training... We will be starting tomorrow. In the mean time please enjoy these bonuses. 
                  
                  </p><br />

                  <h3>Resources 1</h3>
                  <p>https://drive.google.com/drive/folders/1aCAWxDiPVf5auz3nj-5zVjlMeVR-007k</p><br />

                  <h3>Resources 2</h3>
                  <p>https://drive.google.com/drive/folders/1VEHE4nyt1zhkAeKtNmJa_07KeIwH4yJo</p><br />

                  <h3>Resources 3</h3>
                  <p>https://drive.google.com/drive/folders/1rSvwF7HNTHlKEKI_aBNwioTJB0DCqE1z</p><br />

                  <h3>Telegram Channel for resources:</h3>
                  <p>https://t.me/PSD_mockups</p><br />
                  
                  <h3>Books every designer must Read</h3>
                  <p>https://drive.google.com/folderview?id=1gGNufssSYpJuzSc--eXHcCGiOOVAjXh8</p><br />

                  <h3>MUST WATCH 1</h3>
                  <p>Kindly check these videos out on how to install the various apps and software needed</p>
                  <p>https://drive.google.com/drive/folders/1VLDvafcZkMNbEA6QxKKsJzhlwVXFqDqQ?usp=sharing</p><br />

                  <h3>Graphic Design Resources 1</h3>
                  <p>https://drive.google.com/folderview?id=1c1sclfsU1ayALLRypgy5IORrJb1vRyB7</p><br />

                  <h3>🚫 *Don't skip this* 🚫</h3>
                  <p>This link would direct you to videos on design fundamentals. I have done great justice to them and there is no need for me to be repeating them here again</p>
                  <p>https://drive.google.com/folderview?id=1b7Agi1HyW4So4FFdNRBVOzizMzwsvBow</p><br />

                  <p>* More are coming in</p><br />


                  <p>***********************</p><br />


                  <p>
                  Good evening great minds, we will be meeting by 8pm. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY ONE) Wednesday</h5>
                  <p>
                  Good evening great minds, and welcome to DAY ONE of our training. 
                  </p><br />

                  <p>
                  This week would be for introduction and setting up of your design environment. Practical sections will start next week. 
                  </p><br />

                  <p>
                  Today I would explain some grounds rules and things we all need to know about TGA. 
                  </p><br />

                  <h3>Time For Classes</h3><br />
                  <h5>Monday - Tuesday</h5>
                  <p>WhatsApp 8PM - 9PM</p><br />

                  <h5>Live Clases (YouTube)</h5>
                  <p>Saturday 8PM</p><br />

                  <p>Fridays would be for questions and answer</p><br />

                  <p>Nevertheless, we would have classes here today, tomorrow, and friday</p><br />

                  <h3>SOFTWARE AND APP</h3><br />
                  <p>Photoshop</p>
                  <p>CorelDraw</p>
                  <p>Canva</p>
                  <p>Pixellab</p><br />

                  <h5>Laptop Users</h5>
                  <p>Photoshop</p>
                  <p>CorelDraw</p>

                  <h5>Smartphone Users</h5>
                  <p>Canva</p>
                  <p>Pixellab</p><br />

                  <h5>Phone users, should use this link to download Canva and Pixellab</h5><br />
                  <h5>Canva</h5>
                  <p>https://play.google.com/store/apps/details?id=com.canva.editor</p><br />

                  <h5>Pixellab</h5>
                  <p>https://play.google.com/store/apps/details?id=com.imaginstudio.imagetools.pixellab</p><br />

                  
                  <p></p>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={canvaImg} alt="example Img"/>
                    <img src={pixellabImg} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />

                  <h5>Photoshop and CorelDraw Installation Files</h5>
                  <p>https://docs.google.com/document/d/1-yONaRjm09BXaQN41AgI0KFUmD8TazcTX6Hx_V__taY/edit?usp=sharing</p><br />
                  
                  <p>You Can download Photoshop & CorelDraw from</p>
                  <p><a href='https://filecr.com' rel="noreferrer" target='_blank'>Filecr</a></p>
                  <p><a href='https://getintopc.com' rel="noreferrer" target='_blank'>Getintopc</a></p><br />

                  <h5>Tomorrow we will continue with INTRODUCTION TO GRAPHIC DESIGN</h5><br />

                  <h3 className="chris">Your Bonuses</h3><br />

                  <h3>Resources 1</h3>
                  <p>https://drive.google.com/drive/folders/1aCAWxDiPVf5auz3nj-5zVjlMeVR-007k</p><br />

                  <h3>Resources 2</h3>
                  <p>https://drive.google.com/drive/folders/1VEHE4nyt1zhkAeKtNmJa_07KeIwH4yJo</p><br />

                  <h3>Resources 3</h3>
                  <p>https://drive.google.com/drive/folders/1rSvwF7HNTHlKEKI_aBNwioTJB0DCqE1z</p><br />

                  <h3>Telegram Channel for resources:</h3>
                  <p>https://t.me/PSD_mockups</p><br />
                  
                  <h3>Books every designer must Read</h3>
                  <p>https://drive.google.com/folderview?id=1gGNufssSYpJuzSc--eXHcCGiOOVAjXh8</p><br />

                  <h3>MUST WATCH 1</h3>
                  <p>Kindly check these videos out on how to install the various apps and software needed</p>
                  <p>https://drive.google.com/drive/folders/1VLDvafcZkMNbEA6QxKKsJzhlwVXFqDqQ?usp=sharing</p><br />

                  <h3>Graphic Design Resources 1</h3>
                  <p>https://drive.google.com/folderview?id=1c1sclfsU1ayALLRypgy5IORrJb1vRyB7</p><br />

                  <h3>🚫 *Don't skip this* 🚫</h3>
                  <p>This link would direct you to videos on design fundamentals. I have done great justice to them and there is no need for me to be repeating them here again</p>
                  <p>https://drive.google.com/folderview?id=1b7Agi1HyW4So4FFdNRBVOzizMzwsvBow</p><br />

                  <h5>The other bonuses will be sent to your e-mail and the rest will be given after the completion of the course.</h5><br />
                  
                  <h5>Don't forget to Like and Follow Us on our social handles:</h5>
                  <div className="social-icon">
                    <a href="https://www.linkedin.com/company/totlesoft/"><img src={navIcon1} alt="Icon" /></a>
                    <a href="https://www.facebook.com/totlesoft/"><img src={navIcon2} alt="Icon" /></a>
                    <a href="https://www.instagram.com/totlesoft/"><img src={navIcon3} alt="Icon" /></a>
                  </div>
                  <br /><br />
                  <p>Also share the link with your friends. Thanks.</p>
                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />




                  <br />
                  <p>
                  Good evening great minds, we will be meeting by 8pm. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY TWO) Thursday.</h5>
                  <p>
                  Good evening great minds, and welcome to DAY TWO of our training. 
                  </p><br />

                  <p>
                  Please be reminded that this week has been dedicated to introduction and setting up of your design environment. Practical sections will start next week. 
                  </p><br />

                  <p>
                  While we prepare for this great journey I would like to remind you that Knowledge-Not-Applied is a Waste-of-Resources and as such I believe we both have a role to play to ensure your stay in TGA is worth it. Any venture or journey started on a wrong foundation would always crumble.
                  </p><br />

                  <p>The foundamentals/basics of graphic design cannot and will never be over-emphasized, so I would urge you to pay very close attention to today's lesson.</p><br />
                  <h5>A link will be sent at the end of today's class to help you fill for access to the main course Materials.</h5><br />

                  <h5 className="chris">Today's Lesson</h5>
                  <h3>Graphic Design Fundamentals (Elements and Principles)</h3><br />

                  <h5>What is Graphic Design?</h5><br />
                  <p>Graphic design is defined as “the art and practice of planning and projecting ideas and experiences with visual and textual content.”</p>
                  <p>According to American Institute of Graphic Arts (AIGA). Graphic design helps to communicates certain ideas or messages in a visual way. These visuals can be as simple as a business logo, or as complex as page layouts on a website.</p>
                  <p>Graphic design can be used by companies to promote and sell products through advertising, by websites to convey complicated information in a digestible way through infographics.</p>
                  <p>A designer’s job is not first to master a tool, *but to master the act of communication</p><br />

                  <h5>Who is a Graphic Designer?</h5><br />
                  <p>A graphic designer is a professional within the graphic design and graphic arts industry who assembles together images, typography, or motion graphics to create a piece of design.</p>
                  <p>A graphic designer creates the graphics primarily for published, printed or electronic media, such as brochures (sometimes) and advertising.</p>
                  <p>If your design cannot communicate the message it was meant to do, then you have not done a great job.</p>
                  <p>So you see, graphic design is beyond the software.</p>
                  <p>It's a clear show of communication using design elements.</p>
                  <p>Just like every other profession and skill out there, there lots of tremendous benefits for choosing the graphic design path. This is not to say there are no cons to it, definitely there are, but let’s focus on its benefits.</p><br />

                  <h5>Importance of Graphic Design</h5><br />
                  <p>🔰 You can find employment in any industry</p>
                  <p>AUDIO BACKUP - HERE!</p><br />

                  <p>🔰 You can work in multiple environments</p>
                  <p>AUDIO BACKUP - HERE!</p><br />

                  <p>🔰 You can choose to be self-employed</p>
                  <p>AUDIO BACKUP - HERE!</p><br />

                  <p>🔰  You will not get bored</p>
                  <p>AUDIO BACKUP - HERE!</p><br />

                  <h5>For access to the materials:</h5>
                  <p>Send your email address to totlesoft@gmail.com using this subject "MY EMAIL FOR TGA" if you haven't done that already</p><br />

                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />






                  <br />
                  <p>
                  Good evening great minds, we will be meeting by 8pm. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY THREE) Friday.</h5>
                  <p>
                  Good evening great minds, and welcome to DAY THREE of our training. Get ready, you will soon become a suprise to yourself.
                  </p><br />

                  <p>Well, today I will be droping for you voice notes, still in the preparation process because you are not expected to pass through this academy and not be noticed.</p>

                  <p>
                  Please listen to all the following Voice Notes bellow 👇🏽👇🏽👇🏽 and ponder on them. 
                  </p><br />

                  <h5>Audio 1</h5>
                  <p>PASTE HERE</p><br />

                  <h5>Audio 2</h5>
                  <p>PASTE HERE</p><br />

                  <h5>Audio 3</h5>
                  <p>PASTE HERE</p><br />

                  <h5>Audio 4</h5>
                  <p>PASTE HERE</p><br />

                  <h5>Audio 5</h5>
                  <p>PASTE HERE</p><br />

                  <h5>Audio 6</h5>
                  <p>PASTE HERE</p><br />

                  <h5>Audio 7</h5>
                  <p>PASTE HERE</p><br />

                  <h5>Audio 8</h5>
                  <p>PASTE HERE</p><br />

                  <h5>Audio 9</h5>
                  <p>PASTE HERE</p><br />

                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />







                  <br />
                  <p>
                  Good evening great minds, we will be meeting by 9am. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY FOUR) Saturday.</h5>
                  <p>
                  Good morning great minds, and welcome to DAY FOUR of our training. As said before, Sturday shall be for practicals.
                  </p><br />

                  <p>The course materials have been sent out to all who sent their email address to totlesoft@gmail.com using the subject "MY EMAIL FOR TGA"</p><br />

                  <p>If you have not sent yours please do so earlier the better. Thanks.</p><br />

                  <h3>NOTE:</h3>
                  <h5>Ensure to watch this video first before doing anything else👇🏽👇🏽</h5>
                  <p>VIDEO LINK</p><br />

                  <h5>Pause and watch the video first and then come back to continue...</h5><br />

                  <h3>Welcome Back</h3><br />
                  <p>Now that you have watched the video, let's kick off with the assignments for today</p><br />
                  

                  <h3>
                  Assignment 1 
                  </h3><br />

                  <h5 className="chris">Canva 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Pixellab 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Photoshop 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">CorelDraw 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5>NOTE: Assignments are due Wednesday 11:59PM</h5>
                  <p>Watch the video and replicate the design for each assignment</p>
                  <p>Submission is in the general group</p>
                  <p>Once you are done, feel free to submit.</p>

                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />









                  <br />
                  <p>
                  Good evening great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY FIVE) Sunday.</h5>
                  <p>
                  Please keep trying out different designs yourself and alow your creative power to grow. Be free. Try new stuff. 
                  </p><br />

                  <h3>That should be all for today. I will see you all in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />









                  <br />
                  <p>
                  Good evening great minds, we will be meeting by 8pm. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY SIX) Monday.</h5>
                  <p>
                  Good evening great minds, and welcome to DAY SIX of our training.
                  </p><br />

                  <p>The course materials have been sent out to all who sent their email address to totlesoft@gmail.com using the subject "MY EMAIL FOR TGA"</p><br />

                  <p>If you have not sent yours please do so earlier the better. Thanks.</p><br />

                  <h5 className="chris">Today's Lesson</h5>
                  <h3>Design Principles (Cont)</h3><br />

                  <p> Today we would talk deeply about design principles. Please open up your heart and let your creative power to explore.</p><br />

                  <h5>This book also has more on what I want to talk about today.</h5>
                  <p>Link to "Small Book on Graphic Design</p><br />

                  <h3>Balance</h3><br />
                  <p>Balance refers on how you put this elements on your design and avoid to putting all your heavy elements in the same place.</p>
                  <p>There are two types of balance, Symmetrical, that creates balance by align equally weighted elements, and asymmetrical design is the opposite, you align a heavy element with lighter ones to create a contrast effect.</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg1} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Alignment</h3><br />
                  <p>Alignment plays a pivotal role in creating a seamless visual connection with the design elements. It gives an ordered appearance to images, shapes, and blocks of texts by eliminating elements placed in a dishevelled manner.</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg2} alt="example Img"/>
                    <img src={lesImg3} alt="example Img"/>
                    <img src={lesImg4} alt="example Img"/>
                    <img src={lesImg5} alt="example Img"/>
                    <img src={lesImg6} alt="example Img"/>
                    <img src={lesImg7} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Visual Hierarchy</h3><br />
                  <p>In simple words, a hierarchy is formed when extra visual weight is given to the most important element or message in your design.</p>
                  <p>It can be achieved in various ways using larger or bolder fonts to highlight the title; placing the key message higher than the other design elements; or adding focus to larger, more detailed and more colourful visuals than those less relevant or smaller images.</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg8} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Colour</h3><br />
                  <p>Colour is an important design basic and it dictates the overall mood of a design. The colours you pick represent your brand and its tonality, so be careful with the palette you choose. As a graphic designer, it’s always helpful to have a basic knowledge of colour theory, for example, gold & neutral shades evoke an overall feel of sophistication, bright colours signal happiness, and blue creates a feeling of calmness. Colour palettes can be used as a contrast or even to complement the elements.</p><br />

                  <h5>We would dive deeper into colour later in this training.</h5><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg8b} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Contrast</h3><br />
                  <p>Contrast happens when there is a difference between the two opposing design elements.</p>
                  <p>The most common types of contrast are dark vs. light, contemporary vs. old-fashioned, large vs. small, etc.</p>
                  <p>Contrast guides a viewer’s attention to the key elements, ensuring each side is legible.</p><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg9} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Typography</h3><br />
                  <p>Typography is one of the key pillars of design, and it speaks volumes about a brand or an artwork when executed stylistically or even customised.</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg10} alt="example Img"/>
                    <img src={lesImg11} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>Brief Audio on Fonts</h5>
                  <p>AUDIO FILE HERE</p><br />

                  <h3>Graphic Design Best Practices</h3><br />
                  <p> Backgrounds are very important in designs. Your background can dramatically change how your design feels and looks.</p><br />

                  <h3>Understanding Backgrounds and How best to use them</h3><br />
                  <p>Backgrounds are the backbone of great design.</p>
                  <p>Here’s why:</p>
                  <p>Let’s talk about some types of backgrounds and how best to use them in designs.</p>
                  <p>AUDIO FILE HERE</p><br />

                  <h3>SOLID BACKGROUND COLOR</h3><br />
                  <p>To create simple but yet very effective designs, then flat color background is an option.</p>
                  <p>Always remember to keep the mood or tone you want to create with your design in mind when choosing a solid color.</p>
                  <p>Complementary colors (A blend of a very light and very dark) from opposite sides of the color wheel will be a great option. While a lighter combination will exude a softer, more calming effect.</p>
                  <h5>Tips: Using two tones of the same color helps to create a great contrast in your design, without causing diverted attention.</h5><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg12} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>TEXTURE BACKGROUNDS</h3><br />
                  <p>The key to texture is ensuring there are limited colors and simple composition.</p>
                  <p>You don’t want to divert the attention from the overall design, so your texture should be substantially small, behaving as a background and not hogging attention as the foreground.</p>
                  <p>Either use pre-created textures or make your own using small shapes and patterns.</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg13} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>GRADIENT BACKGROUNDS</h3><br />
                  <p>A gradient is excellent to use on digital or print-based projects. The beauty of a gradient is that you can combine almost any color whether neutral or bold, a gradient is always a sophisticated choice.</p>
                  <p>Gradients are a more subtle approach than solid or block color. Whether you apply a radial or linear gradient, you will see a different effect on your designs. The direction will have a direct impact on your audience’s focus point.</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg14} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />
                  
                  <h3>IMAGE BACKGROUNDS</h3>
                  <p>The best way to give your design context is to paint a picture. By including an image in your background, you’ll grab the attention of your audience quickly and immediately relate your message visually. When overlaying type and elements, keep the detail of your image in mind.</p>
                  <p>Your image background should help in conveying the message or theme of your background.</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg15} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <p>I understand some people are yet to get the file. Kindly send your email address to totlesoft@gmail.com using the subject "MY EMAIL FOR TGA"</p><br />

                  <h5>NOTE: Assignments are due Wednesday 11:59PM</h5>
                  <p>Watch the video and replicate the design for each assignment</p>
                  <p>Submission is in the general group</p>
                  <p>Once you are done, feel free to submit.</p>

                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />







                  <br />
                  <p>
                  Good evening great minds, we will be meeting by 8pm. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY SEVEN) Tuesday.</h5>
                  <p>
                  For our class today, we would be having one of our BONUS PACK which is an Audio Pack: 
                  </p><br />
                  <h3>How To Improve <span className="chris">Productivity</span> as a Graphic Designer</h3><br />

                  <p>Listen to them and allow your imaginative power to flow freely. This is to help us focus on our assignments</p>
                  <h5>This special Audio Bundle would help you to build your mindset as a graphic designer.</h5><br />

                  <p>Please listen to each file and apply it as concerned.</p><br />

                  <h3>1. Introduction</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>2. True Productivity</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>3. Becoming More Productive</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>4. Challenges to Productivity</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>5. Importance of Time Management</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>6. Importance of Goal Setting</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>7. Excellent Work Process</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>8. Loving What You Do</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>9. Tracking Your Progress</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>10. Advantages of Personal Organization</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>11. Follow and Learn from the Best Hands</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>12. Learn Some More</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>13. Mistakes to Avoid</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>14. Summary/Conclusion</h3><br />
                  <p>FILE LINK</p><br />

                  <h3>Note</h3><br />
                  <p>While doing your your assignments, please those using LAPTOP TO DESIGN (Focus firstly on CorelDraw and Photoshop), Leter on you can now use your phone for the Canva and Pixellab assignment.</p><br />

                  <p>While those using SMARTPHONE TO DESIGN (Should focus firstly on Canva and Pixellab), Leter on you can now use your Laptop for the CorelDraw and Photoshop assignment.</p><br />
                  <p>In that way you would get more understanding out of both. Don't rush everything at once.</p>
                  <p>These are different platforms and should not be rushed, but taken one at a time.</p><br />


                  <p>I see that some people are yet to get the file. Kindly send your email address to totlesoft@gmail.com using the subject "MY EMAIL FOR TGA"</p><br />

                  <h5>NOTE: Assignments are due Wednesday 11:59PM</h5>
                  <p>Watch the video and replicate the design for each assignment</p>
                  <p>Submission is in the general group</p>
                  <p>Once you are done, feel free to submit.</p>



                  <h3>That should be all for today. I will see you all in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />




                  <br />
                  <p>
                  Good morning great minds, we will be having our second assignments today by 9am. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY EIGHT) Wednesday.</h5>
                  <p>
                  Good morning great minds, and welcome to DAY EIGHT of our training.
                  </p><br />

                  <p>The course materials have been sent out to all who sent their email address to totlesoft@gmail.com using the subject "MY EMAIL FOR TGA"</p><br />

                  <p>If you have not sent yours please do so earlier the better. Thanks.</p><br />

                  <h3>NOTE:</h3>
                  <h5>Ensure to watch this video first before doing anything else👇🏽👇🏽</h5>
                  <p>VIDEO LINK</p><br />

                  <h5>Pause and watch the video first and then come back to continue...</h5><br />

                  <h3>Welcome Back</h3><br />
                  <p>Now that you have watched the video, let's kick off with the assignments for today</p><br />
                  

                  <h3>
                  Assignment 2 
                  </h3><br />

                  <h5 className="chris">Canva 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Pixellab 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Photoshop 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">CorelDraw 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5>NOTE: Assignments are due Sunday 11:59PM</h5>
                  <p>Watch the video and replicate the design for each assignment</p>
                  <p>Submission is in the general group</p>
                  <p>Once you are done, feel free to submit.</p>

                  <h3>That will be all for today. See You in Class Tomorrow</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />






                  <br />
                  <p>
                  Good evening great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY NINE) Thursday.</h5>
                  <p>
                  Please keep trying out different designs yourself and alow your creative power to grow. Be free. Try new stuff. 
                  </p><br />

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />





                  <br />
                  <p>
                  Good evening great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY TEN) Friday.</h5>
                  <p>
                  Please continue trying out different designs yourself and alow your creative power to grow. Be free. Try new stuff. 
                  </p><br />

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />





                  <br />
                  <p>
                  Good morning great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY ELEVEN) Saturday.</h5>
                  <p>
                 Today i will give you free access to an audio message from Totlesoft Graphic Academy to motivate and re-wire your design mindset. Listen to the audio and ponder on it. 
                  </p><br />
                  <h5>Below is the link to the Audio</h5><br />
                  <>AUDIO LINK</>

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />






                  <br />
                  <p>
                  Good morning great minds, remember to tryout all you have been taught so far and more.  
                  </p><br />

                  <h5 className="chris">No Class Today (DAY TWELVE) Sunday.</h5>
                  

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />




                  <br />
                  <p>
                  Good evening great minds, we will be meeting by 8pm. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY THIRTEEN) Monday.</h5>
                  <p>It's another great week</p>
                  <p>We will be getting another assignment after today's class</p>
                  <p>
                 Today we would continue from where we stopped last week. 
                  </p><br />
                  <h5 className="chris">Today's Lesson</h5>
                  <h3>What is font psychology?</h3><br />

                  <p>Before we jump into why font psychology is so important (and how to use it in your designs to inspire specific emotional responses with your audience), let’s talk about what, exactly, font psychology is.</p><br />

                  <p>In a nutshell, font psychology is the study of how different fonts impact thoughts, feelings, and behaviors.</p><br />

                  <h5>Write this somewhere</h5>
                  <p>From today henceforth I (name here) would avoid the wrong fonts</p><br />

                  <h3>Why is font psychology so important?</h3><br />

                  <p>Now that we have covered what font psychology is, let’s jump into why font psychology is so important.</p><br />

                  <p>Font psychology is simply allowing you to choose the right fonts for your design</p><br />

                  <p>Bottom line: Choosing the wrong fonts can have a detrimental effect on your design. And understanding font psychology is so important because it helps you avoid choosing those less-than-ideal fonts</p><br />

                  <h3>FONT PSYCHOLOGY</h3>
                  <p>There are a number of different elements you can use to evoke specific emotions in your designs. </p><br />
                  <p>You can use colors or shapes or layout to create a wide spectrum of feelings in your audience from happiness to sadness to excitement. </p><br />
                  <p>But there’s one design element that’s often overlooked that can have a huge impact on your audience’s emotional response to your designs, and that’s FONTS</p><br />

                  <h3>Types of Fonts and Usage Examples</h3><br />

                  <h5>SERIF</h5>
                  <p>Serif fonts are the most classic of the bunch; when you use a serif font in your designs, it tells your audience you’re an established and traditional company they can trust.</p><br />
                  <p>Some of the associations and emotional responses you can expect from using a serif font in your designs include:</p><br />
                  <p>🔰 Trust</p>
                  <p>🔰 Respect</p>
                  <p>🔰 Authority</p>
                  <p>🔰 Formality</p><br />

                  <p>Serif fonts are a great fit for more traditional brands and industries, including:</p>

                  <p>🔰 Financial companies</p>
                  <p>🔰 Law firms</p>
                  <p>🔰 Insurance companies</p>
                  <p>🔰 Consultants</p>
                  <p>🔰 Educational Institutions, etc.</p><br />

                  <h3>SANS SERIF</h3>
                  <p>Think of sans serif fonts as serif’s more up-to-date, sophisticated cousin. These fonts are typically viewed as cool, sleek, and modern.</p><br />
                  <p>Because of their prominence in the tech world, sans serif fonts are also strongly associated with being cutting edge and tech-savvy.</p><br />
                  <p>Some of the associations and emotional responses you can expect from using a sans serif font in your designs include:</p><br />
                  
                  <p>🔰 Modern</p>
                  <p>🔰 Trust</p>
                  <p>🔰 Straightforward</p>
                  <p>🔰 Tech-focused</p>
                  <p>🔰 Cutting-edge</p>
                  <p>🔰 Sophisticated</p><br />

                  <p>Sans serif fonts are a great fit for any brand who wants their designs to be viewed as innovative, bold, and sophisticated, including:</p>
                  <p>* Tech Companies</p>
                  <p>* Fashion Brands </p>
                  <p>* Statups, etc. </p><br />

                  <h5>SCRIPT</h5>
                  <p>Script fonts are much more elaborate and detailed than other font categories; they lend a “special” look and feel that can elevate designs to a more elegant and sophisticated level.</p><br />
                  <p>Because they replicate handwriting, they also have a more personal touch than other typefaces. Depending on the font, they can also feel fun and whimsical or more traditional and old-fashioned making script fonts one of the most versatile categories in the design world.</p><br />
                  <p>Some of the associations and emotional responses you can expect from using a script font in your designs include:</p><br />
                  <p>* Elegant</p>
                  <p>* Fancy</p>
                  <p>* Creative</p>
                  <p>* Sophisticated</p>
                  <p>* Happy</p>
                  <p>* Personal</p>
                  <p>* Whimsical</p>
                  <p>* Traditional</p><br />

                  <p>Script fonts can be a fantastic choice for a number of brands and industries that are going for an elegant, whimsical, and/or personal touch with their designs, including:</p>
                  <p>* Food and beverage brands</p>
                  <p>* Children’s-focused brands</p>
                  <p>* Fashion brands</p><br />

                  <h3>UNDERSTANDING COLORS</h3>
                  <p>Earlier we talked about colors and I promised we would dive deeper into it in later lesson, here it is...</p><br />

                  <h3>Types of Colors</h3>
                  <p>* Primary colors</p>
                  <p>* Secondary colors</p>
                  <p>* Tertiary colors</p><br />

                  <h3>PRIMARY COLORS</h3>
                  <p>Primary colors in the RGB color wheel are the colors that, added together, create pure white light. These colors are red, green and blue.</p>
                  <p>In the RYB color wheel, primary colors are colors that can’t be mixed from other colors.</p>
                  <p>There are three primary colors: red, yellow, and blue.</p><br />

                  <h3>SECONDARY COLORS</h3>
                  <p>Secondary colors are colors that result from mixing two primary colors.</p>
                  <p>There are three secondary colors. In the RGB color wheel, these are cyan, magenta and yellow. When you mix light, red and green make yellow, green and blue make cyan, and blue and red make magenta.</p>
                  <p>In the RYB color wheel, the secondary colors are purple (red mixed with blue), orange (red mixed with yellow), and green (yellow mixed with blue).</p><br />

                  <h3>TERTIARY COLORS</h3>
                  <p>Tertiary colors are colors made by combining a secondary color with a primary color. There are six tertiary colors. In the RGB color wheel these are orange, chartreuse green, spring green, azure, violet and rose.</p>
                  <p>In the RYB color wheel, the tertiary colors are red-orange, yellow-orange, yellow-green, blue-green, blue-violet, and red-violet.</p><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg16} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Shade</h3>
                  <p>A shade is created by adding black to a base hue, darkening the color. This creates a deeper, richer color. Shades can be quite dramatic and can be overpowering.</p><br />

                  <h3>Tint</h3>
                  <p>A tint is created by adding white to a base hue, lightening the color. This can make a color less intense, and is useful when balancing more vivid color combinations.</p><br />

                  <h3>Tones</h3>
                  <p>A tone is created by combining black and white or grey with a base hue. Like tints, tones are subtler versions of the original color. Tones are less likely to look pastel, and can reveal complexities not apparent in the base color.</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg17} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Hue</h3>
                  <p>A hue* is basically any color on the color wheel. When you are using a color wheel or a color picker, you can adjust the saturation and luminance of a hue.</p><br />

                  <h3>Saturation</h3>
                  <p>Saturation is simply the intensity or purity of the color.</p><br />

                  <h3>Luminance or Value</h3>
                  <p>This refere to the amount of brightness or light in a color.</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg18} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>TYPES OF COLOR COMBINATION</h3><br />
                  <h5>Complementary</h5>
                  <p>Two colors that are on opposite sides of the color wheel. This combination provides a high contrast and high impact color combination together, these colors will appear brighter and more prominent.</p><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg19} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Monochromatic</h3>
                  <p>Three shades, tones and tints of one base color. Provides a subtle and conservative color combination. This is a versatile color combination that is easy to apply to design projects for a harmonious look.</p><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg20} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Analogous</h3>
                  <p>Three colors that are side by side on the color wheel. This color combination is versatile, but can be overwhelming. To balance an analogous color scheme, choose one dominant color, and use the others as accents.</p><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg21} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Triadic</h3>
                  <p>Three colors that are evenly spaced on the color wheel. This provides a high contrast color scheme, but less so than the complementary color combination making it more versatile. This combination creates bold, vibrant color palettes.</p><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg22} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>Tetradic</h3>
                  <p>Four colors that are evenly spaced on the color wheel. Tetradic color schemes are bold and work best if you let one color be dominant, and use the others as accents. The more colors you have in your palette, the more difficult it is to balance,</p><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={lesImg23} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3>MEANING OF COLORS</h3>
                  <p>Simply click on the link below to learn more about the meaning of colors/</p>
                  <p><a href='https://www.canva.com/colors/color-meanings/' rel="noreferrer" target='_blank'>https://www.canva.com/colors/color-meanings/</a></p><br />

                  <h5>I believe we must have been full today</h5>
                  <p>Please remember, knowledge not applied is simply a waste of time and resources</p>
                  <h3>That should be all for today.</h3><br />

                  <p>Please drop your comments on today's lesson at the general group and also:</p>
                  <p>* 4 Things you've learnt today</p>
                  <p>* Your 'wow' moment</p>
                  <p>* and questions</p><br />
                  <p>We shall now be getting our 3rd assignment</p><br />

                  <h3>NOTE:</h3>
                  <h5>Ensure to watch this video first before doing anything else👇🏽👇🏽</h5>
                  <p>VIDEO LINK</p><br />

                  <h5>Pause and watch the video first and then come back to continue...</h5><br />

                  <h3>Welcome Back</h3><br />
                  <p>Now that you have watched the video, let's kick off with the assignments for today</p><br />
                  

                  <h3>
                  Assignment 3 
                  </h3><br />

                  <h5 className="chris">Canva 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Pixellab 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Photoshop 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">CorelDraw 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5>NOTE: Assignments are due Wednesday 11:59PM</h5>
                  <p>Watch the video and replicate the design for each assignment</p>
                  <p>Submission is in the general group</p>
                  <p>Once you are done, feel free to submit.</p>


                  <h3>I will see you all in our next Class. Cheers!</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />








                  <br />
                  <p>
                  Good evening great minds, we will be meeting by 8pm. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY FOURTEEN)Tuesday.</h5>
                  <p>It's another great day guys. How was your day? Mine was splendid.</p>
                  <p>Today we would talk about ways to improve productivity</p><br />

                  <h5 className="chris">Today's Lesson</h5>
                  <h3>Tips to better productivity as a graphic designer</h3><br />

                  <p>Your productivity would determine your creativity strength</p>
                  <p>As a graphic designer, it is very important to ensure you continually become productive</p>
                  <p>Just as we smartly deal with our day-to-day issues of life, we designers can also increase our work productivity by adopting some key strategies.</p><br />
                  
                  <h3>Manage Your Projects</h3>
                  <p>Give 15-30 minutes at the start of the day to managing your projects.</p>
                  <p>This you should especially do if you are busy with multiple projects. Just go over all those tasks and make sure that you are working on them as per the schedule.</p><br />

                  <h3>Track And Manage Your Time</h3>
                  <p>Many designers, like most of us, spend their valuable time on social media, watching YouTube videos, or playing online games. So, keep a tab on how much time you are wasting on the non-productive activities.</p>
                  <p>This will make you more aware of the value of your time and will help bring your focus back to your main job of creating designs.</p>
                  <p>In a simple term, you will be able to track and manage your time efficiently.</p><br />

                  <h3>Keep A Notebook</h3>
                  <p>Designers often delay creative work as they wait for some inspirational graphic design ideas to strike their minds. So, keep a notebook or sketchbook and write your thoughts so that you do not finding them hard to remember.</p><br />

                  <h3>Prioritize Each Task</h3>
                  <p>The most important design tasks must be at the top of your priority list. It also gives you a sense of urgency as the deadline for these works may be approaching nearer. This way, you can avoid suddenly start working on the least important tasks. You can make multiple such lists for a single project. You can start the day’s work immediately as you already know your priorities.</p><br />

                  <h3>Turn Off The Internet</h3>
                  <p>The Internet is the most significant source of distraction for creative people. If you struggle to focus on the task, just disconnect your Internet, turn off the apps that consume your lot of time, and shut off your Wi-Fi. Soon you will find your productivity level soaring.</p><br />

                  <h3>Take Regular Breaks</h3>
                  <p>Sometimes, working tirelessly on a design project ultimately becomes irritating, and it leads to loss of productivity. Therefore, when pondering about how to become more creative, do not forget to include taking breaks regularly as a strategy to re-energize your creative powers.</p>
                  <p>Just walk around, talk to someone, or indulge in other exciting activities for a change. It is a proven tactic to come back to work with renewed focus.</p><br />

                  <h3>Browse Design Galleries</h3>
                  <p>Sometimes, designers take a long time to get inspiration for a design project. But if you visit design galleries online while taking a coffee break or entertaining yourself, you go through hundreds of design ideas.</p>
                  <p>Many such designs are inspirational and give you new ideas. Remember, standing on the shoulders of others helps you see further.</p>

                  <h3>Know Your Circadian Rhythm</h3>
                  <p>Circadian rhythms are simply the physical, mental, and behavioral changes that follow a daily cycle.</p>
                  <p>Many of us have a particular time of the day when we feel energetic and full of creative ideas.</p>
                  <p>We all have this unique circadian rhythm. Find out which are the happiest hours of the day when you are full of energy to work on challenging tasks.</p>
                  <p>Then, schedule your most important design tasks for the hours when you are charged up.</p>
                  <p>Similarly, do the low energy tasks at the time you generally are less vibrant.</p><br />

                  <h3>Outsource The Minor Tasks</h3>
                  <p>Your main concern and focus should be the most critical design project, which is also your core interest. But many minor design related tasks also consume your lot of time that ultimately impacts your productivity potential</p>
                  <p>Therefore, outsource these trivial but still must-do tasks. These tasks may be removing a background from a product photo, color correction, and photo retouching, converting a raster logo to vector, etc.</p>
                  <p>You can then devote your entire time to the main design work that you think is important.</p><br />

                  <h3>Make A Checklist</h3>
                  <p>One of the most effective productivity hacks is to make checklists</p>
                  <p>Checklists are highly useful in standardizing workflows and keeping on the day’s tasks you need to accomplish. You can meet your quality goals in this way.</p>
                  <p>Checklists will surely help you keep an eye on the progress of your design projects. When more members join your team, making a checklist becomes even more important.</p><br />

                  <h3>Set Step By Step Actions For Your Tasks</h3>
                  <p>When your design business grows, you need to track how your sales, marketing, and interaction strategies are working. For that, you should prepare guidelines for your team to follow so that every procedure critical to your business is standardized.</p><br />

                  <h3>Keep A Library Of Files Accessible</h3>
                  <p>Often, designers are seen wasting their time in finding out vital design files from an unknown source. They save the files somewhere and later forget it. But think of keeping the most used files and your textures in one artboard or one file that you can access instantly from PS or AI.</p>
                  <p>For designers who work in a team, they can keep the files accessible through Dropbox or other such apps.</p><br />

                  <h3>Learn To Convince Clients</h3>
                  <p>After you have created a design to the best of your ability, the job does not end there. You still have to convince the clients that the design suits their brand. The clients will not accept a design just because you say that it looks cool.</p>
                  <p>So, one of the productive hacks for the designers is that they should learn how to convince clients about the usefulness of the design. You should learn how to present an overview of your design process and how to justify your design when clients ask questions.</p><br />

                  <h5>I believe we have gotten something today</h5>
                  <p>Please feel free to leave your comments at the general group, your 'wow' moments and 4 things you learnt today.</p><br />

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />






                  <br />
                  <p>
                  Good evening great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY FIFTEEN) Wednesday.</h5>
                  <p>
                  Please continue trying out different designs yourself and alow your creative power to grow. Be free. Try new stuff. 
                  </p><br />

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />





                  <br />
                  <p>
                  Good evening great minds, hope you're refreshing on what you've learn in previous classes? 
                  </p><br />

                  <h5 className="chris">Practical Day (DAY FIFTEEN) Thursday.</h5>
                  <p>
                  Today we will be getting our fourth assignment 
                  </p><br />

                  <h3>NOTE:</h3>
                  <h5>Ensure to watch this video first before doing anything else👇🏽👇🏽</h5>
                  <p>VIDEO LINK</p><br />

                  <h5>Pause and watch the video first and then come back to continue...</h5><br />

                  <h3>Welcome Back</h3><br />
                  <p>Now that you have watched the video, let's kick off with the assignments for today</p><br />
                  

                  <h3>
                  Assignment 4 
                  </h3><br />

                  <h5 className="chris">Canva 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Pixellab 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Photoshop 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">CorelDraw 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5>NOTE: Assignments are due Sunday 11:59PM</h5>
                  <p>Watch the video and replicate the design for each assignment</p>
                  <p>Submission is in the general group</p>
                  <p>Once you are done, feel free to submit.</p>


                  <h3>I will see you all in our next Class. Cheers!</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />







                  <br />
                  <p>
                  Good evening great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY SIXTEEN) Friday.</h5>
                  <p>
                  Please continue trying out different designs yourself and alow your creative power to grow. Be free. Try new stuff. 
                  </p><br />

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />







                  <br />
                  <p>
                  Good morning great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY SEVENTEEN) Saturday.</h5>
                  <p>
                  Hi guys, just a reminder that you should continue trying out different designs yourself and alow your creative power to grow. Be free. Try new stuff. 
                  </p><br />

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />







                  <br />
                  <p>
                  Good evening great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY EIGHTEEN) Sunday.</h5>
                  <p>
                  Hi guys, just a reminder that you should continue trying out different designs yourself and alow your creative power to grow. Be free. Try new stuff. 
                  </p><br />

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />







                  <br />
                  <p>
                  Good evening great minds, we will be meeting by 8pm. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY NINETEEN) Monday.</h5>
                  <p>It's another great week</p><br />

                  <p>Today we will be seeing some live session replay by Totlesoft Graphic Academy -TGA.</p>
                  <h5 className="chris">Creativity and Marketing Strategies for Graphic Designers</h5>

                  <h3>TGA Creative Week (Day 1)</h3>
                  <p>Here is a replay of the day 1 live session of TGA Creative Week</p>
                  <h5>* 10 Sales and Marketing Strategies for Graphic Designers</h5>
                  <p><a href='https://www.youtube.com/watch?v=BKvCCTdav5Q' rel="noreferrer" target='_blank'>https://www.youtube.com/watch?v=BKvCCTdav5Q</a></p><br /><br />

                  <h3>TGA Creative Week (Day 2)</h3>
                  <p>Here is a replay of the day 2 live session of TGA Creative Week</p>
                  <h5>* How to get PAYING and LOYAL CLIENTS as a graphic designer</h5>
                  <p><a href='https://youtu.be/xYr10zMKmm8' rel="noreferrer" target='_blank'>https://youtu.be/xYr10zMKmm8</a></p><br /><br />

                  <h3>TGA Creative Week (Day 3)</h3>
                  <p>Here is a replay of the day 3 live session of TGA Creative Week</p>
                  <h5>* Going Beyond The Normal</h5>
                  <p><a href='https://www.youtube.com/watch?v=crMIw2WtjWI' rel="noreferrer" target='_blank'>https://www.youtube.com/watch?v=crMIw2WtjWI</a></p><br /><br />

                  <h3>TGA Creative Week (Day 4)</h3>
                  <p>Here is a replay of the day 4 live session of TGA Creative Week</p>
                  <h5>* The role of content creation and social media in growing a business.</h5>
                  <p><a href='https://www.youtube.com/watch?v=b7Y41fwXGus' rel="noreferrer" target='_blank'>https://www.youtube.com/watch?v=b7Y41fwXGus</a></p><br /><br />

                  <h3>TGA Creative Week (Day 5)</h3>
                  <p>Here is a replay of the day 5 live session of TGA Creative Week</p>
                  <h5>* How to gain online presence as a graphic designer</h5>
                  <p><a href='https://www.youtube.com/watch?v=9vth0FjQi-c' rel="noreferrer" target='_blank'>https://www.youtube.com/watch?v=9vth0FjQi-c</a></p><br /><br />

                  <h3>BENEFITS OF ONLINE PRESENCE</h3>
                  <p>I would now walk you through some simple tips and steps that helps me stay VISIBLE and RELEVANT online as a graphic designer</p>
                  <p>The need to be visible online is not something that you should bargain or careless about.</p>
                  <p>Yes, I know you may want to run a physical business as a graphic designer, the online world would be a great addition to your business.</p><br />

                  <h5>You can check this video out later</h5>
                  <p><a href='https://youtu.be/-Xce3yNq0-o' rel="noreferrer" target='_blank'>https://youtu.be/-Xce3yNq0-o</a></p><br /><br />

                  <h3>TIPS</h3><br />

                  <h5>Brand yourself very well</h5>
                  <p>You need to have a good brand before you can even think of having good clients</p>
                  <p>A brand is a business that was created to solve a particular problem in the lives of people.</p>
                  <p>Branding is what people say about your business or service</p>
                  <p>Branding has a lot of emotions attached to it, and It is very important to get it rtight</p>
                  <p>We would dive deeper on branding next week</p><br />

                  <h5>Have a skill that is needed</h5>
                  <p>The first point of contact to people online is value.</p>
                  <p>People gather around those that have something to offer.</p>
                  <p>No matter the level of your knowledge, there is always something you can offer people.</p>
                  <p>To dominate online and to be in the known, you need to have some amount of value.</p><br />

                  <h5>More on this in audio</h5>
                  <p>AUDIO</p><br />

                  <h5>Some More on this also in audio</h5>
                  <p>AUDIO</p><br />

                  <h5>Be active online</h5>
                  <p>You can not dominate a territory you are not familiar with</p>
                  <p>For you to become visible online, people need to see you constantly and as much as possible</p>
                  <p>I am not saying you should spend the whole of your day online being unproductive.</p>
                  <p>EVERY MINUTE SPENT ONLINE SHOULD BE TO EARN MONEY</p><br />

                  <h5>More on this in audio</h5>
                  <p>AUDIO</p><br />

                  <h5>Learn to attract people and solve a problem for them</h5>
                  <p>If it's just one thing you can do for people, go ahead.</p>
                  <p>If all you know is 'Y', there are millions of people who don't know 'Y'</p><br />

                  <h5>More on this in audio</h5>
                  <p>AUDIO</p><br />

                  <h5>Understand your audience</h5>
                  <p>You need to have a clear understanding of who you have been sent to</p>
                  <p>Because the people you are sent to don't have the time to argue with your message at all</p><br />

                  <h5>More on this in audio</h5>
                  <p>AUDIO</p><br />

                  <h5>Track your progress</h5>
                  <p>Always have a clear goal for your online presence and ensure you monitor your progress.</p>
                  <p>That way you would know if what you are doing works or not.</p><br />

                  <h5>More on this in audio</h5>
                  <p>AUDIO</p><br />

                  <h5>We will be stoping here today. Tomorrow we would talk about *Lead generation and types of leads*</h5><br />
                  <p>Find bellow our fifth assignment</p>

                  <h3>
                  Assignment 5 
                  </h3><br />

                  <h5 className="chris">Canva 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Pixellab 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Photoshop 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">CorelDraw 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5>NOTE: Assignments are due Wednesday 11:59PM</h5>
                  <p>Watch the video and replicate the design for each assignment</p>
                  <p>Submission is in the general group</p>
                  <p>Once you are done, feel free to submit.</p><br />

                  <h5>Next week is going to be for our projects</h5><br />


                  <h3>I will see you all in our next Class. Cheers!</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />






                  <br />
                  <p>
                  Good evening great minds, we will be meeting by 8pm. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY TWENTY) Tuesday.</h5>
                  <p>Good evening great minds, and welcome to DAY TWENTY of our training. So good to know you're still holding on strong. Keep the spirit high, it is alowed.</p><br />

                  <p>Today we would be talking about Organic Traffic Generation (OTG)</p><br />

                  <p>Let's start with types of traffic</p><br />

                  <h3>Types of Traffic</h3>
                  <p>There are basically three kinds of traffic</p>
                  <p>1. Cold Traffic</p>
                  <p>2. Warm Traffic</p>
                  <p>3. Hot Traffic </p><br />

                  <p>We would take them one after the other, but first, lets understand what organic traffic is</p>
                  <p>Organic traffic is simply *visitors or strangers that interact with your brand or business without the use of ads*</p><br />

                  <h3>Cold Traffic</h3>
                  <p>These are basically people who have never experienced or interacted with your brand or business</p>
                  <p>They are people who have *no feeling for what you do*</p>
                  <p>TGA 7 days free class and other mediums used are aimed at turning cold audience into *ready to buy fans*</p>
                  <p>It just depends on how you handle them </p>
                  <p>Everybody in the cold traffic category is a potential client or customer</p>
                  <p>This is actually where the deal is.</p><br />

                  <h5>Add audio backup here</h5><br />

                  <h3>Warm Traffic</h3>
                  <p>Warm traffic is traffic from friends of friend, influences, or people who may not even take your class.</p>
                  <p>It may be they have read you're book, sen your work, or they might be people whom may have maybe come in contact with you.</p>
                  <p>They also may have heard your name before, or encountered you before, but they have not had a personal relationship or personal encounter with you.</p>
                  <p>Your duty as a business owner is to turn cold traffic into hot traffic.</p>
                  <p>Though the hot audience are the ones holding your money, but remember every cold audience is a potential hot audience.</p><br />

                  <h5>Add audio backup here</h5><br />

                  <h3>Hot Traffic</h3>
                  <p>These are a group of people who have encountered you, people who know, like, and trust you. People who lookup to you.</p>
                  <p>These are people you've worked for or people who have taken your training before or bought something from you.</p><br />

                  <h5>Add audio backup here</h5><br />

                  <h3>Ways to grow organic Leads</h3>
                  <p>What you're abut to learn is what we have used and still using till date</p>
                  <p>We all started from using organic means.</p>
                  <p>We're teaching organic leads now because that's what everybody can do without having to learn a lot of things like Facebook or instagram ads and all that</p>
                  <p>Please get this straight, Ads are powerful but the strength of your ads would depend on how well your brand have grown using the organic approach.</p>
                  <p>Organic ads brings you testimonies and comments you can use to strengthen your paid ads</p><br />

                  <h3>Put Up Free Ebooks</h3>
                  <p>No one rejects free things, especially when the free comes with so much VALUE.</p>
                  <p>Choose a topic people will want to read.</p>
                  <p>Use the e-book to show them that you truly know this your area.</p>
                  <p>Build competence with it.</p><br />

                  <h5>Add audio backup here</h5><br />

                  <h3>Organize WhatsApp Free Classes Or Other free classes</h3>
                  <p>Don't be scared to exchange your knowledge for Value (Money)</p>
                  <p>Organize a very high value free class and put a call out for people to come</p>
                  <p>There is no place for shy people in this world when it comes to selling</p>
                  <p>Show them the WHAT and the WHY.</p>
                  <p>Create all the necessary scenarios and emotions to make them come to you for the *how* and sell to them</p>
                  <p>Position your brand for excellence</p>
                  <p>TGA recently added over 3000 contact and counting, from giving out undiluted value</p><br />

                  <h5>Add audio backup here</h5><br />

                  <h3>Use your WhatsApp Status, Broadcast and Newsletter</h3>
                  <p>You can use your status and broadcast list to generate leads and traffic for your business</p>
                  <p>However, please note that I don't encourage randomly sending people messages</p>
                  <p>Don't go to people or groups in the name of *your network is your net worth*</p>
                  <p>Find a way to get people to willingly give you their number</p><br />

                  <h5>Add audio backup here</h5><br />

                  <h3>INFLUENCE AND MARKETING</h3>
                  <h5>Value is simply the currency for transaction</h5><br />
                  <p>Click link to lesting to the following audio messages</p><br />

                  <h3>WhatsApp Automation</h3>
                  <p><a href='https://drive.google.com/folderview?id=1IHUrBNbN7lYs4wUAkKsBJnwyIR6X9Wxp' rel="noreferrer" target='_blank'>https://drive.google.com/folderview?id=1IHUrBNbN7lYs4wUAkKsBJnwyIR6X9Wxp</a></p><br />

                  <h3>How to Scale with Contents</h3>
                  <p><a href='https://drive.google.com/folderview?id=13aLHMs7F2YnmS5AEU4sjyLt8jup5oEoK' rel="noreferrer" target='_blank'>https://drive.google.com/folderview?id=13aLHMs7F2YnmS5AEU4sjyLt8jup5oEoK</a></p><br />

                  <h5>I believe we must have been full today</h5>
                  <p>Please remember, knowledge not applied is simply a waste of time and resources</p>
                  <h3>That should be all for today.</h3><br />

                  <p>Please drop your comments on today's lesson at the general group and also:</p>
                  <p>* 4 Things you've learnt today</p>
                  <p>* Your 'wow' moment</p>
                  <p>* and questions</p><br />

                  <h5>Short Audio Note</h5><br />

                  <h3>I will see you all in our next Class. Cheers!</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />







                  <br />
                  <p>
                  Good evening great minds, we will be meeting by 8pm. 
                  </p><br />

                  <h5 className="chris">Class Begins (DAY TWENTY-ONE) Wednesday.</h5>
                  <p>Good evening great minds, and welcome to DAY TWENTY-ONE of our training. So good to know you're still holding on strong. Keep the spirit high, it is alowed.</p><br />

                  <p>Today we wom't be talking much rather, we would be having the sixth and last assignment in this training.</p><br />
                  
                  <h3>
                  Assignment 6 
                  </h3><br />

                  <h5 className="chris">Canva 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Pixellab 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">Photoshop 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5 className="chris">CorelDraw 👇🏽</h5>
                  <p>Assignment Here</p><br />

                  <h5>NOTE: Assignments are due Sunday 11:59PM</h5>
                  <p>Watch the video and replicate the design for each assignment</p>
                  <p>Submission is in the general group</p>
                  <p>Once you are done, feel free to submit.</p><br />

                  <h5>Be reminded that next week is going to be for our projects</h5><br />


                  <h3>I will see you all in our next Class. Cheers!</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />






                  <br />
                  <p>
                  Good evening great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY TWENTY-TWO) Thursday.</h5>
                  <p>
                  Hi guys, just a reminder that you should continue trying out different designs yourself and alow your creative power to grow. Be free. Try new stuff. 
                  </p><br />

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />








                  <br />
                  <p>
                  Good evening great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY TWENTY-THREE) Friday.</h5>
                  <p>
                  Please continue trying out different designs yourself and alow your creative power to grow. Be free. Try new stuff. 
                  </p><br />

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />







                  <br />
                  <p>
                  Good morning great minds, hope you're refreshing on what you've learn within the week? 
                  </p><br />

                  <h5 className="chris">No Class Today (DAY TWENTY-FOUR) Saturday.</h5>
                  <p>
                  Hi guys, just a reminder that you should continue trying out different designs yourself and alow your creative power to grow. Be free. Try new stuff. 
                  </p><br />

                  <h3>That should be all for today. I will see you all in our next Class</h3>
                  <p>********************************************************************</p>
                  <br /><br /><br /><br /><br />

                 
                 </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
